<template>
    <div class="heading-analytics-practice">
        <h2 class="heading-analytics-practice__heading">
            {{ headingText }}
            <span class="heading-analytics-practice__highlighted-text">{{ highlightedText }}</span>
        </h2>
        <p class="heading-analytics-practice__desc">{{ descText }}</p>
    </div>
</template>
<script>
    export default {
        props: {
            headingText: {
                type: String,
                default: 'Lorem Ipsum:',
            },
            highlightedText: {
                type: String,
                default: 'Dolor',
            },
            descText: {
                type: String,
                default: 'Lorem ipsum dolor sit amet consectetur nulla elit.'
            }
        },
    };
</script>
<style scoped src="@/css/components/heading-analytics-practice.css"></style>